import { useEffect, useState } from "react";
import { cx } from "@/utils/cx";

type MerchantLogoProps = {
  name: string;
  logoUrl?: string | null;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
};

const sizeClasses = {
  xs: "size-6",
  sm: "size-10",
  md: "size-12",
  lg: "size-14",
};

const textSizeClasses = {
  xs: "text-[9px]",
  sm: "text-xs",
  md: "text-xs",
  lg: "text-sm",
};

const Initials = ({ name, size, className }: { name: string; size: "xs" | "sm" | "md" | "lg"; className?: string }) => (
  <div
    className={cx(
      sizeClasses[size],
      "rounded-lg bg-secondary flex items-center justify-center shrink-0 ring-1 ring-primary",
      className,
    )}
  >
    <span className={cx(textSizeClasses[size], "font-bold text-tertiary")}>{name.substring(0, 3).toUpperCase()}</span>
  </div>
);

export const MerchantLogo = ({ name, logoUrl, size = "md", className }: MerchantLogoProps) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [logoUrl]);

  if (logoUrl && !imgError) {
    return (
      <img
        src={logoUrl}
        alt={`${name} logo`}
        className={cx(sizeClasses[size], "rounded-lg object-cover shrink-0", className)}
        onError={() => setImgError(true)}
      />
    );
  }

  return <Initials name={name} size={size} className={className} />;
};
